export default {
  w4d: "4D",
  coming_soon: "មកដល់ឆាប់ៗនេះ...",
  virtual_games: "ជំនួញនិម្មិត",
  support: "ទំនាក់ទំនងយើង",
  bet_limit: "កម្រិតការភ្នាល់",
  favorites: "សំណព្វ",
  note: "ចំណាំ",
  my_bets: "ការភ្នាល់របស់ខ្ញុំ",
  my_account: "គណនីរបស់ខ្ញុំ",
  contact_us: "ទាក់ទងមកយើង",
  report: "របាយការណ៍",
  help_support: "ជំនួយ និងការគាំទ្រ",
  currency: "រូបិយប័ណ្ណ",
  others: "ផ្សេងៗ",
  welcome: "សូមស្វាគមន៍",
  account_id: "លេខសម្គាល់គណនី",
  password: "ពាក្យសម្ងាត់",
  account: "គណនី",
  all_sports: "កីឡាទាំងអស់",
  my_sports: "កីឡា",
  action: "សកម្មភាព",
  accept_better_odds: "ទទួលយកអត្រាកាន់តែល្អ",
  accept_any_odds: "ទទួលយកអត្រាទាំងអស់",
  auto_refresh_odds: "ធ្វើបច្ចុប្បន្នភាពអត្រាដោយស្វ័យប្រវត្តិ",
  auto_refresh: "បច្ចុប្បន្នភាពស្វ័យប្រវត្តិ",
  auto_refreshing: "កំពុងបច្ចុប្បន្នភាព...",
  all_markets: "ទីផ្សារទាំងអស់",
  away: "ភ្ញៀវ",
  all: "ទាំងអស់",
  accepted: "បានទទួលយក",
  add_to_parlay: "បន្ថែមទៅភាឡេ",
  add_to_booster: "បន្ថែមទៅបូស្តឺ",
  amount: "ចំនួនទឹកប្រាក់",
  amount_before_balance: "ចំនួនមុនសមតុល្យ",
  amount_after_balance: "ចំនួនបន្ទាប់ពីសមតុល្យ",
  bet_slip: "សន្លឹកភ្នាល់",
  bet_credit: "ឥណទានភ្នាល់",
  bet_list: "បញ្ជីភ្នាល់",
  betting: "ការភ្នាល់",
  balance: "សមតុល្យ",
  betting_statement: "របាយការណ៍ភ្នាល់",
  bet_types: "ប្រភេទភ្នាល់",
  bet_type: "ប្រភេទភ្នាល់",
  bs: "B/S",
  bet_summary: "សង្ខេបភ្នាល់",
  bet_reject: "បោះបង់ភ្នាល់",
  bets: "ការភ្នាល់",
  bet: "ភ្នាល់",
  booster: "ជំនួយពិន្ទុ",
  casino: "កាស៊ីណូ",
  mini_casino: "មីនីកាស៊ីណូ",
  cash_balance: "សមតុល្យសាច់ប្រាក់",
  change_account_password: "ផ្លាស់ប្តូរពាក្យសម្ងាត់គណនី",
  current_password: "ពាក្យសម្ងាត់បច្ចុប្បន្ន",
  confirm_new_password: "បញ្ជាក់ពាក្យសម្ងាត់ថ្មី",
  customize_sports_order: "ប្ដូរតម្រៀបកីឡាដោយផ្ទាល់ខ្លួន",
  choice: "ជម្រើស",
  credit: "ឥណទាន",
  commission: "កម្រៃជើងសារ",
  customize: "ប្ដូរតាមបំណង",
  cancel: "បោះបង់",
  confirmation: "ការបញ្ជាក់",
  closing_balance: "សមតុល្យបញ្ចប់",
  clear_filter: "សំអាតតម្រង",
  debit: "ដាប៊ីត",
  display_language: "ភាសាបង្ហាញ",
  default_event_sorting: "ការតម្រៀបព្រឹត្តិការណ៍លំនាំដើម",
  default_stake: "ភាគលានលំនាំដើម",
  date: "កាលបរិច្ឆេទ",
  draw: "ស្មើ",
  draw_cancel: "ស្មើ",
  dec: "ធ្េសឹម",
  double_line: "បន្ទាត់ទ្វេដង",
  disable: "បិទ",
  dec_odds: "អត្រាធ្េសឹម",
  id_odds: "អត្រាឥណ្ឌូ",
  double_chance: "ឱកាសទ្វេដង",
  enable: "បើក",
  event_sorting: "ការតម្រៀបព្រឹត្តិការណ៍",
  e_sports: "កីឡា​អេឡិចត្រូនិច",
  edit: "កែសម្រួល",
  early: "ដើម",
  event: "ព្រឹត្តិការណ៍",
  even: "គូ",
  first_goal: "គ្រាប់បាល់ដំបូង",
  first_half: "វគ្គទីមួយ",
  final: "ចុងក្រោយ",
  full_time: "ពេញម៉ោង",
  fold: "បោះបង់",
  first_5_inn: "5 វគ្គដំបូង",
  games: "ល្បែង",
  given_credit: "ឥណទានបានផ្តល់",
  group: "ក្រុម",
  goal: "គ្រាប់បាល់",
  half_time: "ពាក់កណ្តាលម៉ោង",
  hide_header: "លាក់ក្បាល",
  hk: "ហុងកុង",
  hk_odds: "អត្រាហុងកុង",
  home: "ទំព័រដើម",
  id: "អត្តសញ្ញាណ",
  inactive: "អសកម្ម",
  inplay: "កំពុងលេង",
  keno: "គីណូ",
  kickoff: "ចាប់ផ្ដើមការប្រកួត",
  lottery: "សំបុត្រជ័យលាភ",
  login: "ចូល",
  logout: "ចាកចេញ",
  last_login: "ការចូលចុងក្រោយ",
  last_transaction: "ប្រតិបត្តិការចុងក្រោយ",
  live_streaming: "ទស្សនាពេលមានផ្ទាល់",
  live_tv: "ទស្សនាផ្ទាល់",
  live_match: "ការប្រកួតផ្ទាល់",
  live: "ផ្សាយផ្ទាល់",
  live_center: "មជ្ឈមណ្ឌលផ្ទាល់",
  livecasino: "កាស៊ីណូផ្ទាល់",
  loss: "ការខាតបង់",
  lost: "បានបាត់",
  lose: "ចាញ់",
  lose_all: "ចាញ់ទាំងអស់",
  lose_half: "ចាញ់ពាក់កណ្តាល",
  last_bet: "ភ្នាល់ចុងក្រោយ",
  last_goal: "គ្រាប់ចុងក្រោយ",
  mobile: "ទូរស័ព្ទចល័ត",
  message: "សារ",
  my_bet: "ភ្នាល់របស់ខ្ញុំ",
  my_favorites: "ចំណង់ចំណូលចិត្ត",
  market_type: "ប្រភេទទីផ្សារ",
  match: "ការប្រកួត",
  message_history: "ប្រវត្តិសាររបស់ខ្ញុំ",
  my: "របស់ខ្ញុំ",
  market: "ទីផ្សារ",
  main_markets: "ទីផ្សារសំខាន់ៗ",
  my_odds: "អត្រាមាឡេ",
  min: "អប្បបរមា",
  max: "អតិបរមា",
  max_payout: "ការទូទាត់អតិបរមា",
  main: "សំខាន់",
  corners: "ជ្រុង/ការកក់",
  specials: "ពិសេស",
  mix_parlay: "ភ្នាល់ចម្រុះ",
  moneyline: "បន្ទាត់ប្រាក់",
  no_goal: "គ្មានគ្រាប់បាល់",
  normal_announcements: "ការជូនដំណឹងធម្មតា",
  nickname: "ឈ្មោះហៅក្រៅ",
  new_password: "ពាក្យសម្ងាត់ថ្មី",
  new: "ថ្មី",
  "no/": "ល.រ.",
  normal_sorting: "តម្រៀបទៀងទាត់",
  other_markets: "ទីផ្សារផ្សេងទៀត",
  outstanding: "លេចធ្លោ",
  odds_type: "ប្រភេទអត្រា",
  odds: "អត្រា",
  opening_balance: "សមតុល្យដើម",
  outright: "ជ័យលាភីផ្ទាល់",
  on: "បើក",
  off: "បិទ",
  outstanding_bet: "ភ្នាល់នៅសល់",
  over: "លើស",
  odd: "គូសេសសោម",
  hdp: "អង់ដិខេប",
  ou: "លើស/ទាប",
  oe: "គូ/សេស",
  oxt: "1X2",
  ml: "បន្ទាត់ប្រាក់",
  password_expiry: "ពេលផុតកំណត់ពាក្យសម្ងាត់",
  parlay: "ភ្នាល់ចម្រុះ",
  page_display: "ការបង្ហាញទំព័រ",
  page_type: "ប្រភេទទំព័រ",
  page_size: "ទំហំទំព័រ",
  personal_message: "សារផ្ទាល់ខ្លួន",
  process_bet: "ដាក់ភ្នាល់",
  payout: "ការទូទាត់",
  pending: "រង់ចាំ",
  quick_bet: "ភ្នាល់រហ័ស",
  quick_bet_stake: "ចំនួនភ្នាល់រហ័ស",
  result: "លទ្ធផល",
  restore: "ស្ដារ",
  remark: "កំណត់សម្គាល់",
  ref_no: "លេខយោង",
  remove_from_parlay: "ដកចេញពីចម្រុះ",
  remove_from_booster: "ដកចេញពីបូស្ទ័រ",
  running: "កំពុងដំណើរការ",
  rules: "ច្បាប់",
  rules_regulations: "ច្បាប់ និងបទបញ្ជា",
  sports: "កីឡា",
  show_balance: "បង្ហាញសមតុល្យ",
  statement: "របាយការណ៍",
  settings: "ការកំណត់",
  search_team: "ស្វែងរកក្រុម",
  show_header: "បង្ហាញក្បាល",
  submit: "ដាក់ស្នើ",
  set_nickname: "កំណត់ឈ្មោះហៅក្រៅ",
  single: "ឯកតា",
  save: "រក្សាទុក",
  show_score_map: "បង្ហាញផែនទីពិន្ទុ",
  stake: "ចំនួនភ្នាល់",
  status: "ស្ថានភាព",
  sort: "តម្រៀប",
  sportsbook: "កីឡាកស៊ីណូ",
  sum: "សរុប",
  special_announcements: "ការជូនដំណឹងពិសេស",
  subtotal: "សរុបរង",
  single_line: "បន្ទាត់តែ១",
  sort_by_time: "តម្រៀបតាមពេល",
  slots: "ម៉ាស៊ីនស្លុត",
  mini_slots: "ម៉ាស៊ីនស្លុតតូច",
  select_leagues: "ជ្រើសរើសលីគ",
  settled_amount: "ចំនួនបានសង",
  turnover: "ប្រតិបត្ដិការប្រាក់",
  today: "ថ្ងៃនេះ",
  time: "ពេលវេលា",
  team: "ក្រុម",
  to: "ទៅកាន់",
  trans_time: "ពេលវេលាដោះដូរ",
  total: "សរុប",
  total_goal: "គ្រាប់បាល់សរុប",
  treble: "បីសន្លឹក",
  transaction_date: "កាលបរិច្ឆេទប្រតិបត្តិការ",
  transfer_method: "វិធីផ្ទេរ",
  transfer: "ផ្ទេរ",
  under: "ក្រោម",
  void: "មោឃៈ",
  reject: "បដិសេធ",
  rejected: "បានបដិសេធ",
  valid_turnover: "ប្រតិបត្តិការដែលមានសុពលភាព",
  win: "ឈ្នះ",
  won: "បានឈ្នះ",
  won_all: "ឈ្នះទាំងអស់",
  won_half: "ឈ្នះពាក់កណ្តាល",
  waiting: "កំពុងរង់ចាំ",
  yes: "បាទ/ចាស",
  no: "ទេ",
  yesterday: "ម្សិលមិញ",
  monday: "ថ្ងៃចន្ទ",
  tuesday: "ថ្ងៃអង្គារ",
  wednesday: "ថ្ងៃពុធ",
  thursday: "ថ្ងៃព្រហស្បតិ៍",
  friday: "ថ្ងៃសុក្រ",
  saturday: "ថ្ងៃសៅរ៍",
  sunday: "ថ្ងៃអាទិត្យ",
  all_league: "ទាំងអស់",
  match_completed: "បានបញ្ចប់",
  match_pending: "រង់ចាំលទ្ធផល",
  match_cancelled: "សងប្រាក់វិញ",
  match_cancelled_1h: "សងប្រាក់វិញ 1H",
  match_cancelled_2h: "សងប្រាក់វិញ 2H",
  match_suspended: "ផ្អាកការប្រកួត",
  match_suspended_1h: "ផ្អាក 1H",
  match_suspended_2h: "ផ្អាក 2H",
  check_all: "ពិនិត្យទាំងអស់",
  selected_only: "បានជ្រើសរើសប៉ុណ្ណោះ",
  filtered: "បានចម្រោះ",
  turn_on: "បើក",
  turn_off: "បិទ",
  preference: "ចំណង់ចំណូលចិត្តរបស់ខ្ញុំ",
  market_1: "មុន",
  market_2: "ថ្ងៃនេះ",
  market_3: "កំពុងលេង",
  american_football: "បាល់ទាត់អាមេរិក",
  soccer: "បាល់ទាត់",
  basketball: "បាល់បោះ",
  baseball: "បេស់បុល",
  esports: "អេសផ័រដ៍",
  esports2: "អេសផ័រដ៍",
  tennis: "តេននីស",
  manila_suite: "លេងហ្គេម",
  bangkok_suite: "SA Gaming",
  vegas_suite: "Evolution",
  vietnam_suite: "CT855",
  phnom_penh_suite: "Pretty Gaming",
  london_suite: "Pragmatic",
  yeebet_suite: "Yeebet",
  events: "ព្រឹត្តិការណ៍",
  brackets: "វគ្គ",
  standing: "ចំណាត់ថ្នាក់",
  euro2020: "តារាង Euro 2020",
  play_now: "លេងឥឡូវនេះ",
  processing: "កំពុងដំណើរការ...",
  big_small: "ធំ/តូច",
  odd_even: "សេស/គូ",
  first_digit: "ខ្ទង់ទី ១",
  second_digit: "ខ្ទង់ទី ២",
  third_digit: "ខ្ទង់ទី ៣",
  forth_digit: "ខ្ទង់ទី ៤",
  total_4d: "សរុប 4D",
  total_3d: "សរុប 3 ខ្ទង់ចុងក្រោយ",
  total_1st2d: "សរុប 2 ខ្ទង់ដំបូង",
  total_last2d: "សរុប 2 ខ្ទង់ចុងក្រោយ",
  official_link: "តំណភ្ជាប់ផ្លូវការណ៍",
  virtual_sports: "កីឡា Virtual",
  virtual_soccer: "បាល់ទាត់ Virtual",
  virtual_horse_racing: "ប្រណាំងសេះ Virtual",
  virtual_dog_racing: "ប្រណាំងឆ្កែ Virtual",
  virtual_motorsport: "កីឡាយានយន្ត Virtual",
  prize1: "រង្វាន់ទី ១",
  prize2: "រង្វាន់ទី ២",
  prize3: "រង្វាន់ទី ៣",
  round1: "ជុំទី ១",
  round2: "ជុំទី ២",
  round3: "ជុំទី ៣",
  round4: "ជុំទី ៤",
  round5: "ជុំទី ៥",
  map1: "ផែនទី ១",
  map2: "ផែនទី ២",
  map3: "ផែនទី ៣",
  map4: "ផែនទី ៤",
  map5: "ផែនទី ៥",
  map6: "ផែនទី ៦",
  map7: "ផែនទី ៧",
  map8: "ផែនទី ៨",
  map9: "ផែនទី ៩",
  map10: "ផែនទី ១០",
  ftmode0: "ទាំងអស់",
  ftmode9: "២ ម៉ោងបន្ទាប់",
  ftmode1: "៤ ម៉ោងបន្ទាប់",
  ftmode2: "៨ ម៉ោងបន្ទាប់",
  ftmode3: "ឥឡូវ ~ ០០:០០",
  ftmode4: "០០:០០ ~ ០៤:០០",
  ftmode5: "០៤:០០ ~ ១២:០០",
  continue: "បន្ត",
  highlight: "បន្លិចពិសេស",
  show_all_time: "បង្ហាញពេលវេលាទាំងអស់",
  back: "ត្រឡប់ក្រោយ",
  fishing: "នេសាទ",
  upnext: "បន្ទាប់",
  no_video: "គ្មានវីដេអូ",
  mm_odds: "អត្រាភាគរយမြန်မာ",
  mmo_parlay: "မြန်မာ ပារ្លេ",
  myanmar: "မြန်မာ", 
  slashfruit: "កាត់ផ្លែឈើ",
  happyfish: "ត្រីសប្បាយ",
  legendofphoenix: "រឿងព្រេងនៃផេនីក",
  themonkeyking2: "ស្តេចស្វា ភាគទី ២",
  fishingwar: "សង្គ្រាមនេសាទ",
  goddefense: "ការការពាររបស់ទេវតា",
  mini_games: "ហ្គេមតូចៗ",
  combo: "បញ្ចូលគ្នា",
  total_bet: "ការភ្នាល់សរុប",
  total_stake: "ចំនួនភ្នាល់សរុប",
  sysparlay: "ប្រព័ន្ធបារ៉ាឡេ",
  total_match: "ការប្រកួតសរុប",
  combination: "បញ្ចូលគ្នា",
  stakeperbet: "ចំនួនភ្នាល់ក្នុងមួយ",
  total_payout: "បង់ចេញអតិបរមា",
  total_accept: "ទទួលសរុប",
  total_reject: "បដិសេធសរុប",
  sum_wl: "ឈ្នះ/ចាញ់សរុប",
  sum_bet: "ចំនួនភ្នាល់សរុប",
  abets: " ការភ្នាល់",
  afold: " ដាក់បង្វិល",
  special_events: "ព្រឹត្តិការណ៍ពិសេស",
  event_euro: "យូរ៉ូ ២០២៤",
  event_copa: "កូបា អាមេរិកា ២០២៤",
  event_olympic: "អូឡាំពិក ២០២៤",
  event_worldcup: "ព្រឹត្តិការណ៍World Cup ២០២២",
  event_club_worldcup: "ពានរង្វាន់ក្លឹបWorld Cup",
  event_women_euro: "យូរ៉ូ ស្ត្រី",
  event_nation_league: "លីកជាតិ",
  event_fifa_club: "ក្លឹប FIFA",
  mini_arcade: "Mini Arcade",
  abandoned: "បានបោះបង់",
  score: "ពិន្ទុ",
  winner: "អ្នកឈ្នះ",
  upcoming: "នឹងមកដល់",
  ko: "K.O ដោយ",
  live22: "Live22",
  pgs: "PGSoft",
  pragmatic: "Pragmatic",
  joker: "Joker",
  lucky_pick: "ម៉ាស៊ីនបារ៉ាឡេ",
  random_pick: "បង្កើត",
  add_pick: "បន្ថែមទៅប័ណ្ណភ្នាល់",
  vgames: "V-ហ្គេម",
  tournament: "ការប្រកួត",
  tournament2: "ការប្រកួត+",
  create_room: "បង្កើតបន្ទប់",
  create_private_room: "បង្កើតបន្ទប់ឯកជន",
  search_room: "ស្វែងរកបន្ទប់",
  join_now: "ចូលឥឡូវនេះ",
  entry_fee: "ថ្លៃចូល",
  pool: "ប្រាក់រង្វាន់ $",
  room: "បន្ទប់",
  matches: "ការប្រកួត",
  private: "ឯកជន",
  public: "សាធារណៈ",
  select_matches: "ជ្រើសរើសការប្រកួត",
  selected: "បានជ្រើសរើស",
  tomorrow: "ថ្ងៃស្អែក",
  room_rate: "អត្រាបន្ទប់",
  room_limit: "កំណត់បន្ទប់",
  room_password: "លេខសម្ងាត់",
  join_room: "ចូលបន្ទប់",
  enter_room: "បញ្ចូលបន្ទប់",
  leave_room: "ចាកចេញពីបន្ទប់",
  joined_only: "មានតែអ្នកចូលរួមប៉ុណ្ណោះ",
  last_betting_time: "ពេលវេលាភ្នាល់ចុងក្រោយ",
  owner: "ម្ចាស់",
  room_id: "លេខសម្គាល់បន្ទប់",
  points: "ពិន្ទុ",
  total_points: "ពិន្ទុសរុប",
  refresh: "ធ្វើបច្ចុប្បន្នភាព",
  details: "ព័ត៌មានលម្អិត",
  bet_id: "លេខសម្គាល់ភ្នាល់",
  room_status: "ស្ថានភាពបន្ទប់",
  winner_rank: "ចំណាត់ថ្នាក់អ្នកឈ្នះ",
  players: "អ្នកលេង",
  rank_show: "ចំណាត់ថ្នាក់",
  rank_hide: "លទ្ធផល",
  refund: "សងប្រាក់វិញ",
  simpleplay: "Simple Play",
  player: "អ្នកលេង",
  place_bet: "ដាក់ភ្នាល់",
  feedback: "មតិយោបល់",
  free_room: "លេងដើម្បីរកប្រាក់",
  match_started: "-",
  jili: "JILI",
  ranking: "ចំណាត់ថ្នាក់",
  total_winning: "ប្រាក់ឈ្នះសរុប",
  first_prize: "រង្វាន់ទី 1",
  second_prize: "រង្វាន់ទី 2",
  third_prize: "រង្វាន់ទី 3",
  participants: "អ្នកចូលរួម",
  place: "ចំណាត់ថ្នាក់",
  current_prize: "ពិន្ទុបច្ចុប្បន្ន",
  next: "បន្ទាប់",
  last_join_time: "ពេលចូលចុងក្រោយ",
  tutorial: "លេងម្តងទៀត",
  introduction: "ការណែនាំ",
  close: "បិទ",
  jackpot: "រង្វាន់ធំ",
  prize: "រង្វាន់",
  exclusive: "ពិសេស",
  uusl: "UU Slots",
  nextspin: "NextSpin",
  dbhash: "DB Hash",
  dbpoker: "DB Poker",
  poker: "ប៉ុកគឺ",
  adjustment: "ការកែសម្រួល",
  error: "បញ្ហា",
  notice: "សេចក្ដីជូនដំណឹង",
  no1: "អ្នកឈ្នះទី 1",
  wow_gaming: "Wow Gaming",
  ai_casino: "AI Casino",
  round_id: "លេខសម្គាល់ជុំ",
  hot: "ក្តៅ",
  red: "ក្រហម",
  blue: "ខៀវ",
  yellow: "លឿង",
  first_ball: "បាល់ទី 1",
  best_5_balls: "បាល់ល្អបំផុត 5",
  wf_gaming: "WF Gaming",
  view_all: "មើលទាំងអស់",
  epicwin: "EpicWin",
  sexy_bacarrat: "Sexy Bacarrat",
  show: "បង្ហាញ",
  hide: "លាក់"

};
